/* Travelpro product lines: distributes line cards into category groups and builds the compare table */
(function () {
  function build(root) {
    if (!root || root.dataset.built) return;
    var tpl = root.querySelector('[data-line-cards]');
    if (!tpl) return;
    root.dataset.built = '1';
    // Storefront text comes translated from the snippet (data-i18n-* on the root, page layout); English is the fallback
    var txt = function (name, fallback) { return root.dataset[name] || fallback; };
    var esc = function (v) { return String(v).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var frag = tpl.content.cloneNode(true);
    Array.prototype.slice.call(frag.querySelectorAll('.tp-line')).forEach(function (card) {
      var cat = card.dataset.category;
      var target = root.querySelector('[data-group-list="' + (cat === 'bags' ? 'bags' : cat === 'accessories' ? 'accessories' : 'luggage') + '"]');
      if (target) target.appendChild(card);
    });
    root.querySelectorAll('.tp-lines__group').forEach(function (g) {
      var n = g.querySelectorAll('.tp-line').length;
      if (!n) g.hidden = true;
      var list = g.querySelector('.tp-lines__list');
      if (list) list.classList.add(n === 1 ? 'tp-lines__list--one' : n === 2 ? 'tp-lines__list--two' : n <= 4 ? 'tp-lines__list--few' : 'tp-lines__list--many');
    });
    var table = root.querySelector('[data-compare-table]');
    if (table) {
      var lines = Array.prototype.slice.call(root.querySelectorAll('[data-group-list="luggage"] .tp-line'));
      var yes = '<span class="tp-yes" aria-label="' + esc(txt('i18nYes', 'Yes')) + '">&#10003;</span>', no = '<span class="tp-no" aria-label="' + esc(txt('i18nNo', 'No')) + '">&ndash;</span>';
      var rows = [
        [txt('i18nShell', 'Shell'), function (l) { return l.dataset.shell || '\u2014'; }],
        [txt('i18nWeight', 'Carry-on weight'), function (l) { return l.dataset.weight || '\u2014'; }],
        [txt('i18nCapacity', 'Carry-on capacity'), function (l) { return l.dataset.capacity || '\u2014'; }],
        [txt('i18nMaterial', 'Material'), function (l) { return l.dataset.material || '\u2014'; }],
        [txt('i18nExpandable', 'Expandable'), function (l) { return l.dataset.expand === 'true' ? yes : no; }],
        [txt('i18nTsa', 'Built-in TSA lock'), function (l) { return l.dataset.tsa === 'true' ? yes : no; }],
        [txt('i18nGlide', 'PrecisionGlide wheels'), function (l) { return l.dataset.glide === 'true' ? yes : no; }],
        [txt('i18nUsb', 'USB port'), function (l) { return l.dataset.usb === 'true' ? yes : no; }],
        [txt('i18nBest', 'Best for'), function (l) { return l.dataset.best || '\u2014'; }]
      ];
      var html = '<thead><tr><th scope="col" class="tp-compare__sticky"></th>' + lines.map(function (l) {
        var thumb = l.dataset.cutout ? '<span class="tp-compare__thumb"><img src="' + l.dataset.cutout + '" alt="" loading="lazy"></span>' : '<span class="tp-compare__thumb"></span>';
        return '<th scope="col"><a href="' + l.dataset.url + '">' + thumb + '<span class="tp-compare__name">' + l.dataset.title + '</span></a></th>';
      }).join('') + '</tr></thead><tbody>';
      rows.forEach(function (r) {
        var cells = lines.map(r[1]);
        // A spec with no value for any line (data the store has not filled in) is left out, not shown as a row of dashes
        if (cells.every(function (v) { return v === '\u2014'; })) return;
        html += '<tr><th scope="row" class="tp-compare__sticky">' + esc(r[0]) + '</th>' + cells.map(function (v) { return '<td>' + v + '</td>'; }).join('') + '</tr>';
      });
      table.innerHTML = html + '</tbody>';
    }
    // Tabs reconfigure the page: one group at a time, or the compare table
    var tabs = root.querySelectorAll('.tp-lines__tabs a');
    if (tabs.length) {
      var groupsWrap = root.querySelector('.tp-lines__groups');
      var compare = root.querySelector('.tp-lines__compare');
      var isPage = root.classList.contains('tp-lines--page');
      // Values match the custom.line_shell data (English); the intro lines are the translated text
      var shellTabs = { hardside: 'Hardside', softside: 'Softside' };
      var shellIntro = { hardside: txt('i18nHardsideIntro', 'Hardside lines, from our flagship down.'), softside: txt('i18nSoftsideIntro', 'Softside lines, from our flagship down.') };
      function show(key, push) {
        tabs.forEach(function (b) { b.classList.toggle('is-active', b.dataset.tab === key); b.setAttribute('aria-selected', b.dataset.tab === key ? 'true' : 'false'); });
        var groupKey = shellTabs[key] ? 'luggage' : key;
        root.querySelectorAll('.tp-lines__group').forEach(function (g) {
          var has = !!g.querySelector('.tp-line');
          // The page only ever shows luggage lines; bags and accessories stay in the dropdown
          if (isPage && g.dataset.group !== 'luggage') { g.hidden = true; return; }
          g.hidden = !(has && g.dataset.group === groupKey);
        });
        var luggage = root.querySelector('[data-group="luggage"]');
        if (luggage) {
          luggage.querySelectorAll('.tp-line').forEach(function (t) {
            t.hidden = !!shellTabs[key] && (t.dataset.shell || '').toLowerCase() !== shellTabs[key].toLowerCase();
          });
          var sub = luggage.querySelector('[data-group-sub]');
          if (sub) {
            // The server-rendered (translated) intro is the default line
            if (sub.dataset.defaultText == null) sub.dataset.defaultText = sub.textContent;
            sub.textContent = shellTabs[key] ? shellIntro[key] : sub.dataset.defaultText;
          }
        }
        if (groupsWrap) groupsWrap.hidden = key === 'compare';
        if (compare) compare.hidden = key !== 'compare';
        if (push && history.replaceState && root.classList.contains('tp-lines--page')) history.replaceState(null, '', '#tp-' + key);
      }
      tabs.forEach(function (a) {
        a.setAttribute('role', 'tab');
        a.addEventListener('click', function (e) { e.preventDefault(); show(a.dataset.tab, true); });
      });
      var initial = root.classList.contains('tp-lines--page') ? (location.hash || '').replace('#tp-', '') : '';
      var valid = Array.prototype.some.call(tabs, function (t) { return t.dataset.tab === initial; });
      // Tabs for empty groups are not rendered, so the first tab is the default (Luggage when it has lines)
      show(valid ? initial : tabs[0].dataset.tab, false);
    }
  }
  function buildAll() { document.querySelectorAll('.tp-lines').forEach(build); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', buildAll); else buildAll();
  new MutationObserver(function () { buildAll(); }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', buildAll);
})();
